import { Text } from '../../../../../../../../mads/Text';
import { MarkupComponents } from '../../../../../../../../shared/components/MarkupComponents/MarkupComponents';
import { useI18n } from '../../../../../../../../shared/I18n';
import { useViewjobOneGraphModel } from '../../../../../../context/ViewJobDataContext';
import { TextLink } from '../../../../JobComponent/TextLink/TextLink';
import { useLogging } from '../../../context/useLogging';

import React, { type ReactNode, useCallback } from 'react';

export type MarkupWrapperProps = {
    label: string;
    linkAriaLabel?: string;
    rtl?: boolean;
    sx?: any;
};

export const MarkupWrapper: React.FunctionComponent<MarkupWrapperProps> = ({
    linkAriaLabel,
    label,
    sx,
}) => {
    const viewjobOneGraphModel = useViewjobOneGraphModel();
    const profileBaseUrl = viewjobOneGraphModel?.jobSeeker?.profile?.profileBaseUrl ?? '';

    const { gettext } = useI18n();
    const logger = useLogging();

    const LinkMarkup = useCallback(
        (children: ReactNode) => {
            return (
                <TextLink
                    onPress={() => logger.logProfileNavClick()}
                    targetUrl={profileBaseUrl}
                    aria-label={linkAriaLabel || gettext('profile (opens in a new window)')}
                    level={1}
                    variant="neutral"
                >
                    {children}
                </TextLink>
            );
        },
        [gettext, linkAriaLabel, logger, profileBaseUrl],
    );

    const TextMarkup = useCallback(
        (children: ReactNode) => {
            if (!sx) {
                return null;
            }

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            return <Text sx={sx}>{children}</Text>;
        },
        [sx],
    );

    return (
        <MarkupComponents
            components={{
                highlight: TextMarkup,
                link: LinkMarkup,
            }}
        >
            {label}
        </MarkupComponents>
    );
};
